// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__ji-gF","navText":"Navbar_navText__15Pbl","navLogo":"Navbar_navLogo__1xkxt","imgLogo":"Navbar_imgLogo__RbOiq"};